import { createSelector } from 'reselect';

const getTabs = (state) => {
    const {
        teamStatsSeasonAllTime: {
            teamComparisonGameType = ''
        } = {},
        loading: {
            isLoading
        } = {}
    } = state;

    let slidesList = ['game', 'season', 'alltime'];

    if (teamComparisonGameType) {
        if (teamComparisonGameType === 'A') {
            slidesList = ['game', 'alltime'];
        }
    } else {
        slidesList = ['game'];
    };

    return {
        slidesList,
        isLoading,
        teamComparisonGameType
    };
};

export const getTabsState = createSelector(
    [getTabs],
    (info) => {
        return info;
    }
);
